export default __webpack_public_path__ + "static/store-badge-microsoft.be5a64bf.svg";